<template>
  <div class="comment-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" class="comment-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运维管理</el-breadcrumb-item>
      <el-breadcrumb-item>评价数据</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="评价列表" name="list">
        <!-- 统计卡片 -->
    <div class="summary-row">
      <div class="summary-card summary-green">
        <div class="summary-label">好评率</div>
        <div class="summary-value">{{ summary.goodRate }}%</div>
      </div>
      <div
        class="summary-card summary-green clickable"
        :class="{ active: queryInfo.scoreType === 'good' }"
        @click="handleCardClick('good')"
      >
        <div class="summary-label">好评数</div>
        <div class="summary-value">{{ summary.goodCount }}</div>
      </div>
      <div
        class="summary-card clickable"
        :class="{ active: queryInfo.scoreType === 'mid' }"
        @click="handleCardClick('mid')"
      >
        <div class="summary-label">中评数</div>
        <div class="summary-value">{{ summary.midCount }}</div>
      </div>
      <div
        class="summary-card summary-red clickable"
        :class="{ active: queryInfo.scoreType === 'bad' }"
        @click="handleCardClick('bad')"
      >
        <div class="summary-label">差评数</div>
        <div class="summary-value">{{ summary.badCount }}</div>
      </div>
      <div
        class="summary-card summary-orange clickable"
        :class="{ active: queryInfo.replyStatus === 'unreplied' }"
        @click="handleCardClick('unreplied')"
      >
        <div class="summary-label">未回复</div>
        <div class="summary-value">{{ summary.unrepliedCount }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">评价总数</div>
        <div class="summary-value">{{ summary.total }}</div>
      </div>
    </div>

    <!-- 主内容区 -->
    <el-card class="comment-card" shadow="hover">
      <!-- 筛选工具栏 -->
      <div class="tab-toolbar">
        <el-radio-group v-model="queryInfo.searchMode" size="small" @change="onSearchModeChange">
          <el-radio-button label="store">项目/店铺</el-radio-button>
          <el-radio-button label="mt">美团门店</el-radio-button>
        </el-radio-group>
        <el-select v-model="selectedBrand" placeholder="选择品牌" size="small" style="width: 140px;" clearable @change="handleSearch">
          <el-option v-for="item in brandList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-input
          v-model="queryInfo.keyword"
          :placeholder="searchPlaceholder"
          clearable
          size="small"
          style="width: 180px"
          @clear="handleSearch"
          @keyup.enter.native="handleSearch"
        ></el-input>
        <el-input
          v-model="queryInfo.wmPoiId"
          placeholder="门店ID"
          clearable
          size="small"
          style="width: 140px"
          @clear="handleSearch"
        ></el-input>
        <el-select
          v-model="queryInfo.scoreType"
          placeholder="评分类型"
          clearable
          size="small"
          style="width: 110px"
          @change="handleSearch"
        >
          <el-option label="好评" value="good"></el-option>
          <el-option label="中评" value="mid"></el-option>
          <el-option label="差评" value="bad"></el-option>
        </el-select>
        <el-select
          v-model="queryInfo.replyStatus"
          placeholder="回复状态"
          clearable
          size="small"
          style="width: 110px"
          @change="handleSearch"
        >
          <el-option label="已回复" value="replied"></el-option>
          <el-option label="未回复" value="unreplied"></el-option>
        </el-select>
        <el-date-picker
          v-model="queryInfo.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width: 260px"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="handleSearch"
        ></el-date-picker>
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
        <el-button type="success" size="small" icon="el-icon-upload2" @click="importDialogVisible = true">数据导入</el-button>
      </div>

      <!-- 数据表格 -->
      <el-table
        :data="list"
        border
        size="small"
        v-loading="loading"
        :height="tableHeight"
        class="comment-table"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="expand-content">
              <div class="expand-section">
                <span class="expand-title">评价详情：</span>
                <span>{{ scope.row.comment || '（无）' }}</span>
              </div>
              <div class="expand-section" v-if="getReplyList(scope.row).length > 0">
                <span class="expand-title">商家回复：</span>
                <div
                  v-for="(item, idx) in getReplyList(scope.row)"
                  :key="idx"
                  class="reply-item"
                >
                  {{ typeof item === 'string' ? item : (item.comment || item.cleanComment || item.content || JSON.stringify(item)) }}
                </div>
              </div>
              <div class="expand-section" v-else>
                <span class="expand-title">商家回复：</span>
                <span class="no-reply">暂未回复</span>
              </div>
              <div class="expand-section" v-if="getAppendList(scope.row).length > 0">
                <span class="expand-title">用户追评：</span>
                <div
                  v-for="(item, idx) in getAppendList(scope.row)"
                  :key="idx"
                  class="reply-item"
                >
                  {{ typeof item === 'string' ? item : (item.comment || item.cleanComment || item.content || JSON.stringify(item)) }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="项目/店铺" min-width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.projectName || scope.row.storeName">
              <div class="store-main-name">{{ scope.row.projectName || '—' }}</div>
              <div class="store-sub-name">{{ scope.row.storeName || '—' }}</div>
            </div>
            <span v-else class="unlinked-tag">未关联</span>
          </template>
        </el-table-column>
        <el-table-column label="美团门店" min-width="150">
          <template slot-scope="scope">
            <div class="mt-store-cell">
              <div>{{ scope.row.poiName || '—' }}</div>
              <div class="store-sub-name">{{ scope.row.wmPoiId || '—' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="用户昵称" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="评论时间" width="110"></el-table-column>
        <el-table-column label="评价内容" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.comment || '（无）' }}</template>
        </el-table-column>

        <el-table-column prop="id" label="评论ID" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="评分" width="80" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="getScoreTagType(scope.row.orderCommentScore)"
              size="mini"
            >{{ scope.row.orderCommentScore }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="回复状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="getReplyList(scope.row).length > 0 ? 'success' : 'warning'"
              size="mini"
            >{{ getReplyList(scope.row).length > 0 ? '已回复' : '未回复' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-tooltip content="刷新该门店当日评论" placement="top">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-refresh"
                :loading="refreshingKeys.has(scope.$index)"
                :disabled="refreshingKeys.has(scope.$index)"
                @click="handleRefreshRow(scope)"
              >刷新</el-button>
            </el-tooltip>
            <el-tooltip content="该评论已回复" placement="top" :disabled="getReplyList(scope.row).length === 0">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-chat-dot-square"
                :disabled="getReplyList(scope.row).length > 0"
                @click="handleReply(scope)"
              >回复</el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagenum"
        :page-sizes="[20, 50, 100]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="comment-pagination"
      ></el-pagination>
    </el-card>

      <!-- 回复评论弹窗 -->
      <el-dialog
        title="回复评论"
        :visible.sync="replyDialog.visible"
        width="520px"
        :close-on-click-modal="false"
        append-to-body
      >
        <el-form label-width="80px" size="small">
          <el-form-item label="门店">
            <span>{{ replyDialog.row && replyDialog.row.poiName }}</span>
          </el-form-item>
          <el-form-item label="评论">
            <div style="color:#606266;line-height:1.5;">{{ replyDialog.row && replyDialog.row.comment }}</div>
          </el-form-item>
          <el-form-item label="回复内容">
            <div style="margin-bottom: 6px;">
              <el-select
                v-model="replyDialog.templateId"
                placeholder="选择模版快速填充(可选)"
                size="small"
                clearable
                style="width: 100%"
                @change="onTemplateChange"
              >
                <el-option
                  v-for="t in replyDialog.templates"
                  :key="t._id"
                  :label="t.content.length > 30 ? t.content.slice(0, 30) + '…' : t.content"
                  :value="t._id"
                ></el-option>
              </el-select>
            </div>
            <el-input
              type="textarea"
              :rows="4"
              maxlength="200"
              show-word-limit
              v-model="replyDialog.content"
              placeholder="请输入回复内容"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button size="small" @click="replyDialog.visible = false">取消</el-button>
          <el-button type="primary" size="small" :loading="replyDialog.loading" @click="submitReply">提交回复</el-button>
        </span>
      </el-dialog>

      <!-- 数据导入弹窗 -->
      <el-dialog title="评价数据导入" :visible.sync="importDialogVisible" width="480px" :close-on-click-modal="false">
        <el-form label-width="80px" size="small">
          <el-form-item label="选择文件">
            <el-upload
              :action="importUrl"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="handleImportSuccess"
              :on-error="handleImportError"
              :on-progress="handleImportProgress"
              :before-upload="beforeImportUpload"
              :disabled="importUploading"
              accept=".json"
            >
              <el-button type="primary" :loading="importUploading">
                {{ importUploading ? '导入中...' : '点击上传' }}
              </el-button>
              <span slot="tip" class="import-tip"> 仅支持 .json 格式，文件名须以「美团评论」开头，大小不超过 20MB</span>
            </el-upload>
          </el-form-item>
          <el-progress v-if="importUploading" :percentage="importProgress" :stroke-width="6" style="margin-top: 8px" />
        </el-form>
      </el-dialog>
      </el-tab-pane>

      <!-- 差评统计 Tab -->
      <el-tab-pane label="差评统计" name="badRanking">
        <el-card class="comment-card" shadow="hover">
          <!-- 筛选工具栏 -->
          <div class="tab-toolbar">
            <el-radio-group v-model="badRankingSearchMode" size="small" @change="onBadRankingSearchModeChange">
              <el-radio-button label="store">项目/店铺</el-radio-button>
              <el-radio-button label="mt">美团门店</el-radio-button>
            </el-radio-group>
            <el-select v-model="selectedBrand" placeholder="选择品牌" size="small" style="width: 140px;" clearable @change="handleBadRankingSearch">
              <el-option v-for="item in brandList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-input
              v-model="badRankingKeyword"
              :placeholder="badRankingSearchPlaceholder"
              clearable
              size="small"
              style="width: 180px"
              @clear="handleBadRankingSearch"
              @keyup.enter.native="handleBadRankingSearch"
            ></el-input>
            <el-date-picker
              v-model="badRankingDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              style="width: 260px"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            ></el-date-picker>
            <el-button type="primary" size="small" icon="el-icon-search" @click="handleBadRankingSearch">查询</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="handleBadRankingReset">重置</el-button>
          </div>

          <!-- 排名表格 -->
          <el-table
            :data="badRanking.list"
            border
            size="small"
            v-loading="badRanking.loading"
            :height="tableHeight"
            class="comment-table"
          >
            <el-table-column type="index" label="排名" width="70" align="center"
              :index="getBadRankingIndex"></el-table-column>
            <el-table-column label="项目/店铺" min-width="300">
              <template slot-scope="scope">
                <div v-if="scope.row.projectName || scope.row.storeName">
                  <div class="store-main-name">{{ scope.row.projectName || '—' }}</div>
                  <div class="store-sub-name">{{ scope.row.storeName || '—' }}</div>
                </div>
                <span v-else class="unlinked-tag">未关联</span>
              </template>
            </el-table-column>
            <el-table-column prop="poiName" label="门店名称" min-width="220" show-overflow-tooltip></el-table-column>

            <el-table-column prop="wmPoiId" label="门店ID" min-width="120"></el-table-column>
            <el-table-column label="差评数" min-width="100" align="center">
              <template slot-scope="scope">
                <span class="bad-count-num">{{ scope.row.badCount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalCount" label="评价总数" min-width="100" align="center"></el-table-column>
            <el-table-column label="差评率" min-width="100" align="center">
              <template slot-scope="scope">
                <span :class="getBadRateClass(scope.row.badRate)">{{ scope.row.badRate }}%</span>
              </template>
            </el-table-column>
            <el-table-column label="未回复差评" min-width="110" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.badUnrepliedCount > 0" type="warning" size="mini">{{ scope.row.badUnrepliedCount }}</el-tag>
                <span v-else class="bad-rate-low">0</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="90" align="center">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.badCount === 0 ? '该门店暂无差评' : ''" :disabled="scope.row.badCount > 0">
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-data-analysis"
                    :disabled="scope.row.badCount === 0"
                    @click="handleAnalyze(scope.row)"
                  >AI分析</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-pagination
            @size-change="handleBadRankingSizeChange"
            @current-change="handleBadRankingCurrentChange"
            :current-page="badRanking.pagenum"
            :page-sizes="[20, 50, 100]"
            :page-size="badRanking.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="badRanking.total"
            class="comment-pagination"
          ></el-pagination>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <!-- 差评分析弹窗 -->
    <el-dialog
      :title="'差评分析 - ' + analyzeDialog.storeName"
      :visible.sync="analyzeDialog.visible"
      width="800px"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <div v-loading="analyzeDialog.loading" v-if="analyzeDialog.loading" style="min-height:200px"></div>
      <div v-else-if="analyzeDialog.report" class="analysis-report">
        <div class="analysis-meta">
          <el-tag type="info" size="small">分析时间: {{ analyzeDialog.analysisTime }}</el-tag>
          <el-tag type="warning" size="small">已分析 {{ analyzeDialog.analyzedCount }} 条差评</el-tag>
        </div>
        <div class="analysis-content" v-html="renderMarkdown(analyzeDialog.report)"></div>
      </div>
      <div v-else class="analysis-empty">
        <el-empty description="暂无分析结果"></el-empty>
      </div>
      <span slot="footer">
        <el-button size="small" @click="analyzeDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { renderMarkdown as renderMarkdownUtil } from '@/utils/markdown'
import { brandList } from '@/utility/staticData'

export default {
  data () {
    return {
      // 当前激活的 Tab
      activeTab: 'list',

      // 筛选条件
      queryInfo: {
        searchMode: 'store',
        keyword: '',
        wmPoiId: '',
        scoreType: '',
        replyStatus: '',
        dateRange: null
      },

      // 品牌列表
      brandList,
      selectedBrand: '',

      // 列表数据
      list: [],
      total: 0,
      pagenum: 1,
      pagesize: 20,
      loading: false,

      // 统计概览
      summary: {
        total: 0,
        goodCount: 0,
        midCount: 0,
        badCount: 0,
        goodRate: '0.0',
        unrepliedCount: 0
      },

      // 日期快捷选项
      pickerOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近30天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },

      // 差评统计 Tab 数据
      badRanking: {
        list: [],
        total: 0,
        pagenum: 1,
        pagesize: 20,
        loading: false,
        loaded: false
      },
      badRankingDateRange: null,
      badRankingSearchMode: 'store',
      badRankingKeyword: '',

      // 差评分析弹窗
      analyzeDialog: {
        visible: false,
        loading: false,
        storeName: '',
        analyzedCount: 0,
        analysisTime: '',
        report: ''
      },

      // 数据导入
      importDialogVisible: false,
      importUrl: this.$http.defaults.baseURL + 'yunwei/commentData/import',
      uploadHeaders: {
        authorization: window.sessionStorage.getItem('token'),
        Accept: 'application/json'
      },
      importUploading: false,
      importProgress: 0,

      // 行内刷新
      refreshingKeys: new Set(),

      // 评论回复弹窗
      replyDialog: {
        visible: false,
        loading: false,
        row: null,
        content: '',
        templateId: '',
        templates: []
      }
    }
  },
  computed: {
    tableHeight () {
      return window.innerHeight - 380
    },
    // 评价列表 Tab 搜索框 placeholder
    searchPlaceholder () {
      return this.queryInfo.searchMode === 'store' ? '项目名/店铺名' : '美团门店名称'
    },
    // 差评统计 Tab 搜索框 placeholder
    badRankingSearchPlaceholder () {
      return this.badRankingSearchMode === 'store' ? '项目名/店铺名' : '美团门店名称'
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取评价数据列表
    async getList () {
      this.loading = true

      try {
        const params = {
          pagenum: this.pagenum,
          pagesize: this.pagesize
        }

        if (this.selectedBrand) {
          params.brand = this.selectedBrand
        }
        if (this.queryInfo.keyword) {
          params.searchMode = this.queryInfo.searchMode
          params.keyword = this.queryInfo.keyword
        }
        if (this.queryInfo.wmPoiId) {
          params.wmPoiId = this.queryInfo.wmPoiId
        }
        if (this.queryInfo.scoreType) {
          params.scoreType = this.queryInfo.scoreType
        }
        if (this.queryInfo.replyStatus) {
          params.replyStatus = this.queryInfo.replyStatus
        }
        if (this.queryInfo.dateRange && this.queryInfo.dateRange.length === 2) {
          params.startDate = this.queryInfo.dateRange[0]
          params.endDate = this.queryInfo.dateRange[1]
        }

        const { data: res } = await this.$http.get('yunwei/commentData/list', { params })
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return
        }

        this.list = res.data.list || []
        this.total = res.data.total || 0
        if (res.data.summary) {
          this.summary = res.data.summary
        }
      } catch (error) {
        this.$message.error('获取评价数据失败')
        console.error('获取评价数据失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 查询按钮
    handleSearch () {
      this.pagenum = 1
      this.getList()
    },

    // 重置按钮
    handleReset () {
      this.queryInfo = {
        searchMode: 'store',
        keyword: '',
        wmPoiId: '',
        scoreType: '',
        replyStatus: '',
        dateRange: null
      }
      this.pagenum = 1
      this.getList()
    },

    // 搜索模式切换：清空关键字并重新查询
    onSearchModeChange () {
      this.queryInfo.keyword = ''
      this.pagenum = 1
      this.getList()
    },

    // 分页大小变更
    handleSizeChange (newSize) {
      this.pagesize = newSize
      this.pagenum = 1
      this.getList()
    },

    // 页码变更
    handleCurrentChange (newPage) {
      this.pagenum = newPage
      this.getList()
    },

    // 评分标签颜色
    getScoreTagType (score) {
      if (score >= 4) return 'success'
      if (score === 3) return 'info'
      return 'danger'
    },

    // 获取商家回复列表（type=0 为商家回复，type=1 用户追评不算已回复）
    getReplyList (row) {
      if (!row || !Array.isArray(row.eCommentList)) return []
      return row.eCommentList.filter(item => item && item.type === 0)
    },

    // 获取用户追评列表（type 非 0 的元素均视为追评展示）
    getAppendList (row) {
      if (!row || !Array.isArray(row.eCommentList)) return []
      return row.eCommentList.filter(item => item && item.type !== 0)
    },

    // 统计卡片点击：快速切换筛选条件，再次点击取消
    handleCardClick (type) {
      if (type === 'good' || type === 'mid' || type === 'bad') {
        this.queryInfo.scoreType = this.queryInfo.scoreType === type ? '' : type
      } else if (type === 'unreplied') {
        this.queryInfo.replyStatus = this.queryInfo.replyStatus === 'unreplied' ? '' : 'unreplied'
      }
      this.pagenum = 1
      this.getList()
    },

    // Tab 切换处理
    handleTabClick (tab) {
      if (tab.name === 'badRanking' && !this.badRanking.loaded) {
        this.getBadRanking()
      }
    },

    // 获取差评统计排名
    async getBadRanking () {
      this.badRanking.loading = true
      try {
        const params = {
          pagenum: this.badRanking.pagenum,
          pagesize: this.badRanking.pagesize
        }
        if (this.selectedBrand) {
          params.brand = this.selectedBrand
        }
        if (this.badRankingKeyword) {
          params.searchMode = this.badRankingSearchMode
          params.keyword = this.badRankingKeyword
        }
        if (this.badRankingDateRange && this.badRankingDateRange.length === 2) {
          params.startDate = this.badRankingDateRange[0]
          params.endDate = this.badRankingDateRange[1]
        }
        const { data: res } = await this.$http.get('yunwei/commentData/badRanking', { params })
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return
        }
        this.badRanking.list = res.data.list || []
        this.badRanking.total = res.data.total || 0
        this.badRanking.loaded = true
      } catch (error) {
        this.$message.error('获取差评统计失败')
        console.error('获取差评统计失败:', error)
      } finally {
        this.badRanking.loading = false
      }
    },

    // 差评统计查询
    handleBadRankingSearch () {
      this.badRanking.pagenum = 1
      this.getBadRanking()
    },

    // 差评统计重置
    handleBadRankingReset () {
      this.badRankingDateRange = null
      this.badRankingSearchMode = 'store'
      this.badRankingKeyword = ''
      this.badRanking.pagenum = 1
      this.getBadRanking()
    },

    // 差评统计搜索模式切换：清空关键字并重新查询
    onBadRankingSearchModeChange () {
      this.badRankingKeyword = ''
      this.badRanking.pagenum = 1
      this.getBadRanking()
    },

    // 差评统计分页大小变更
    handleBadRankingSizeChange (newSize) {
      this.badRanking.pagesize = newSize
      this.badRanking.pagenum = 1
      this.getBadRanking()
    },

    // 差评统计页码变更
    handleBadRankingCurrentChange (newPage) {
      this.badRanking.pagenum = newPage
      this.getBadRanking()
    },

    // 排名序号（跨页连续）
    getBadRankingIndex (index) {
      return (this.badRanking.pagenum - 1) * this.badRanking.pagesize + index + 1
    },

    // 差评率颜色等级
    getBadRateClass (rate) {
      const r = parseFloat(rate)
      if (r >= 20) return 'bad-rate-high'
      if (r >= 10) return 'bad-rate-mid'
      return 'bad-rate-low'
    },

    // ========== 差评分析相关 ==========

    // 点击分析按钮
    async handleAnalyze (row) {
      this.analyzeDialog.visible = true
      this.analyzeDialog.loading = true
      this.analyzeDialog.storeName = row.poiName
      this.analyzeDialog.report = ''

      try {
        const params = { wmPoiId: row.wmPoiId, poiName: row.poiName }
        if (this.selectedBrand) {
          params.brand = this.selectedBrand
        }
        if (this.badRankingDateRange && this.badRankingDateRange.length === 2) {
          params.startDate = this.badRankingDateRange[0]
          params.endDate = this.badRankingDateRange[1]
        }
        const { data: res } = await this.$http.post('yunwei/commentData/analyzeBadComments', params)
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          this.analyzeDialog.visible = false
          return
        }
        this.analyzeDialog.report = res.data.report
        this.analyzeDialog.analyzedCount = res.data.analyzedCount
        this.analyzeDialog.analysisTime = this.formatAnalysisTime(res.data.analysisTime)
      } catch (error) {
        this.$message.error('分析请求失败，请稍后重试')
        this.analyzeDialog.visible = false
      } finally {
        this.analyzeDialog.loading = false
      }
    },

    // 格式化分析时间
    formatAnalysisTime (isoStr) {
      if (!isoStr) return ''
      try {
        const d = new Date(isoStr)
        const pad = n => String(n).padStart(2, '0')
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
      } catch {
        return isoStr
      }
    },

    // Markdown 转 HTML 渲染（差评 LLM 分析文本；清理走全局公共实现 utils/markdown）
    renderMarkdown (text) {
      if (!text) return ''
      return renderMarkdownUtil(text, { breaks: false })
    },

    // ========== 数据导入相关 ==========

    // 上传前校验（文件类型 + 大小 + 文件名前缀 + 二次确认）
    async beforeImportUpload (file) {
      // 1. 文件类型校验
      if (!file.name.match(/\.json$/i)) {
        this.$message.error('只能上传 .json 格式文件')
        return false
      }
      // 2. 大小限制
      if (file.size / 1024 / 1024 >= 20) {
        this.$message.error('上传文件大小不能超过 20MB')
        return false
      }
      // 3. 文件名前缀校验
      if (!file.name.startsWith('美团评论')) {
        this.$message.error('文件名必须以「美团评论」开头')
        return false
      }
      // 4. 二次确认
      try {
        await this.$confirm(
          `确认导入文件「${file.name}」？\n导入将采用覆盖式写入（已存在的数据将被覆盖，新数据将新建）。`,
          '导入确认',
          { confirmButtonText: '确认导入', cancelButtonText: '取消', type: 'warning' }
        )
      } catch {
        return false // 用户取消
      }
      this.importUploading = true
      this.importProgress = 0
      return true
    },

    // 上传进度
    handleImportProgress (event) {
      this.importProgress = Math.round(event.percent || 0)
    },

    // 导入成功
    handleImportSuccess (res) {
      this.importUploading = false
      this.importProgress = 100
      if (res.meta && res.meta.status !== 200) {
        return this.$message.error(res.meta.msg || '导入失败')
      }
      const count = res.data.count
      this.$message.success(`导入完成，写入 ${count} 条数据`)
      // 关闭弹窗并重置状态
      this.importDialogVisible = false
      this.importProgress = 0
      // 刷新列表
      this.getList()
    },

    // 导入失败
    handleImportError () {
      this.importUploading = false
      this.importProgress = 0
      this.$message.error('导入失败，请检查文件格式是否正确')
    },

    // ========== 行内刷新相关 ==========

    // 刷新某门店某日的评论
    async handleRefreshRow (scope) {
      const row = scope.row
      const key = scope.$index

      if (!row.wmPoiId) {
        this.$message.warning('该评论缺少门店ID')
        return
      }
      if (!row.createTime) {
        this.$message.warning('该评论缺少评论时间')
        return
      }

      // createTime 本身就是 "YYYY-MM-DD" 格式的字符串
      const date = row.createTime

      this.refreshingKeys.add(key)
      this.$forceUpdate()

      try {
        const { data: res } = await this.$http.post(
          'yunwei/commentData/refresh',
          { wmPoiId: row.wmPoiId, date, brand: row.brand || this.selectedBrand || undefined },
          { timeout: 120000 } // 2分钟超时
        )
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg || '刷新失败')
          return
        }
        const count = res.data.count || 0
        this.$message.success(`刷新完成，更新 ${count} 条评论`)
        // 刷新列表
        this.getList()
      } catch (error) {
        if (error.code === 'ECONNABORTED') {
          this.$message.error('刷新超时，请稍后重试')
        } else {
          this.$message.error('刷新失败: ' + (error.message || '未知错误'))
        }
      } finally {
        this.refreshingKeys.delete(key)
        this.$forceUpdate()
      }
    },

    // ========== 评论回复相关 ==========

    // 打开回复弹窗
    handleReply (scope) {
      this.replyDialog.row = scope.row
      this.replyDialog.content = ''
      this.replyDialog.templateId = ''
      this.replyDialog.templates = []
      this.replyDialog.visible = true
      // 根据评价分推导评分类型并加载模版
      const scoreType = this.scoreTypeFromScore(scope.row.orderCommentScore)
      this.loadReplyTemplates(scoreType)
    },

    // 由评价分推导评分类型 good/mid/bad(与 getScoreTagType 阈值一致)
    scoreTypeFromScore (score) {
      if (score >= 4) return 'good'
      if (score === 3) return 'mid'
      return 'bad'
    },

    // 加载当前评价评分类型对应的启用模版
    async loadReplyTemplates (scoreType) {
      try {
        const { data: res } = await this.$http.get('yunwei/commentTemplate/list', {
          params: { scoreType, enabled: 'true' }
        })
        if (res.meta.status === 200) {
          this.replyDialog.templates = res.data || []
        }
      } catch (err) {
        // 模版加载失败不影响回复,静默处理
      }
    },

    // 选择模版后填入回复框(可二次编辑)
    onTemplateChange (templateId) {
      if (!templateId) return
      const tpl = this.replyDialog.templates.find(t => t._id === templateId)
      if (tpl) {
        this.replyDialog.content = tpl.content
      }
    },

    // 提交回复（后端内部已做回复+重新拉取入库，前端 200 后调 getList 同步视图）
    async submitReply () {
      const content = (this.replyDialog.content || '').trim()
      if (!content) {
        this.$message.warning('请输入回复内容')
        return
      }
      const row = this.replyDialog.row
      if (!row || !row.wmPoiId || !row.id || !row.createTime) {
        this.$message.warning('评论信息缺失，无法回复')
        return
      }

      this.replyDialog.loading = true
      try {
        const { data: res } = await this.$http.post(
          'yunwei/commentData/reply',
          {
            // 多品牌支持：优先取评论行自身的品牌，工具栏筛选仅作兜底
            // （后端实际按 wmPoiId→dataChannel 路由，此处 brand 仅用于校验与后续 refresh 写入）
            brand: row.brand || this.selectedBrand || undefined,
            wmPoiId: row.wmPoiId,
            toCommentId: row.id,
            ctime: row.createTime,
            comment: content
          },
          { timeout: 180000 } // 3分钟超时（回复+刷新）
        )
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg || '回复失败')
          return
        }
        this.$message.success(res.meta.msg || '回复成功')
        this.replyDialog.visible = false
        // 后端已重新拉取入库，刷新列表同步视图
        this.getList()
      } catch (error) {
        if (error.code === 'ECONNABORTED') {
          this.$message.error('回复超时，请稍后在评论列表确认是否回复成功')
        } else {
          this.$message.error('回复失败: ' + (error.message || '未知错误'))
        }
      } finally {
        this.replyDialog.loading = false
      }
    }
  }
}
</script>

<style scoped>
.comment-page {
  padding: 0 4px;
}

.comment-breadcrumb {
  margin-bottom: 16px;
}

/* 统计卡片 */
.summary-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.summary-card {
  flex: 1;
  min-width: 120px;
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  padding: 16px 20px;
  text-align: center;
  transition: box-shadow 0.2s;
}

.summary-card:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.summary-card.summary-green .summary-value {
  color: #67c23a;
}

.summary-card.summary-red .summary-value {
  color: #f56c6c;
}

.summary-card.summary-orange .summary-value {
  color: #e6a23c;
}

/* 可点击卡片交互样式 */
.summary-card.clickable {
  cursor: pointer;
  user-select: none;
}

.summary-card.clickable.active {
  border-width: 2px;
  padding: 15px 19px;
}

.summary-card.summary-green.clickable.active {
  border-color: #67c23a;
  background: #f0f9eb;
}

.summary-card.clickable.active:not(.summary-green):not(.summary-red):not(.summary-orange) {
  border-color: #909399;
  background: #f4f4f5;
}

.summary-card.clickable.active:not(.summary-green):not(.summary-red):not(.summary-orange) .summary-value {
  color: #909399;
}

.summary-card.summary-red.clickable.active {
  border-color: #f56c6c;
  background: #fef0f0;
}

.summary-card.summary-orange.clickable.active {
  border-color: #e6a23c;
  background: #fdf6ec;
}

.summary-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
}

.summary-value {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
}

/* 主卡片 */
.comment-card {
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

/* 工具栏 */
.tab-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0 12px;
  flex-wrap: wrap;
}

/* 展开行内容 */
.expand-content {
  padding: 12px 20px;
  background: #fafafa;
}

.expand-section {
  margin-bottom: 8px;
}

.expand-section:last-child {
  margin-bottom: 0;
}

.expand-title {
  font-weight: 600;
  color: #303133;
}

.reply-item {
  padding: 4px 0 4px 12px;
  border-left: 3px solid #dcdfe6;
  margin-top: 4px;
  color: #606266;
}

.no-reply {
  color: #909399;
  font-style: italic;
}

/* 分页 */
.comment-pagination {
  padding: 14px 0 0;
  text-align: right;
}

/* 差评统计 */
.bad-count-num {
  color: #f56c6c;
  font-weight: 600;
  font-size: 16px;
}

.bad-rate-high {
  color: #f56c6c;
  font-weight: 600;
}

.bad-rate-mid {
  color: #e6a23c;
  font-weight: 600;
}

.bad-rate-low {
  color: #67c23a;
}

/* 项目/店铺关联列（与店铺管理页样式一致） */
.store-main-name {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

.store-sub-name {
  color: #909399;
  font-size: 12px;
}

.unlinked-tag {
  color: #c0c4cc;
  font-style: italic;
}

/* 导入提示 */
.import-tip {
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}

/* 差评分析弹窗 */
.analysis-report {
  min-height: 200px;
}

.analysis-meta {
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
}

.analysis-content {
  background: #fafafa;
  padding: 16px 20px;
  border-radius: 8px;
  line-height: 1.8;
  font-size: 14px;
  color: #303133;
  max-height: 500px;
  overflow-y: auto;
}

.analysis-content h2 { font-size: 18px; margin: 16px 0 8px; }

.analysis-content h3 { font-size: 16px; margin: 12px 0 6px; }

.analysis-content h4 { font-size: 14px; margin: 10px 0 4px; }

.analysis-content h5 { font-size: 13px; margin: 8px 0 4px; }

.analysis-content ul { padding-left: 20px; margin: 4px 0; }

.analysis-content li { margin: 2px 0; }

.analysis-content blockquote {
  border-left: 3px solid #409eff;
  padding: 4px 12px;
  margin: 4px 0;
  background: #ecf5ff;
  color: #606266;
}

.analysis-content strong { color: #e6a23c; }

.analysis-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
</style>
